import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Order } from "@/types/ApiTypes";

interface CashierOrdersSearchDataState {
    cashierOrdersSearchData: Order | null;
}

const initialState: CashierOrdersSearchDataState = {
    cashierOrdersSearchData: null,
};

const cashierOrdersSearchDataSlice = createSlice({
    name: "cashierOrdersSearchData",
    initialState,
    reducers: {
        setCashierOrdersSearchData: (state, action: PayloadAction<Order>) => {
            state.cashierOrdersSearchData = action.payload;
        },
        clearCashierOrdersSearchData: (state) => {
            state.cashierOrdersSearchData = null;
        },
    },
});

// Export actions
export const { setCashierOrdersSearchData, clearCashierOrdersSearchData } = cashierOrdersSearchDataSlice.actions;

// Export the reducer
export default cashierOrdersSearchDataSlice.reducer;
